// extracted by mini-css-extract-plugin
export default {"logo_size":"Spinner_logo_size__3siu5"};